export const AVA_PICTURE_DISPLAY_NAME = "AvaPicture";
